<template>
  <IQOS :systemDependency="'preorder'" required>
    <template #title>
      <span v-if="isValid">
        {{ $t("preorder.allow_reservation.title") }}
      </span>
      <span class="orange-4-color" v-else>
        {{ $t("integrations.poster_health.title") }}
      </span>
    </template>
    <p class="iqos-comment mt-16">
      {{ $t("preorder.allow_reservation.comment") }}
    </p>

    <p class="iqos-comment mt-16 orange-4-color" v-if="!isValid">
      {{ $t("preorder.allow_reservation.warning") }}
    </p>

    <BaseDivider color="v1-grey-4" class="mt-16"/>

    <SlideToggleRow class="mt-16" :value="allow_reservation" @input="onToggleReserve">
      {{ $t("preorder.allow_reservation.eat_in") }}
    </SlideToggleRow>
    <BaseDivider color="v1-grey-4" class="mt-16"/>
    <SlideToggleRow
      class="mt-16"
      :value="allow_takeaway"
      @input="onToggleTakeaway"
    >
      {{ $t("preorder.allow_reservation.takeaway") }}
    </SlideToggleRow>
  </IQOS>
</template>

<script>
import SlideToggleRow from "@/components/SlideToggleRow.vue";

export default {
  components: {
    SlideToggleRow,
  },
  data() {
    return {
      allow_reservation: false,
      allow_takeaway: false,
    };
  },
  methods: {
    onToggleReserve() {
      this.allow_reservation = !this.allow_reservation;

      this.$store.commit("setPreorderAllowReservation", this.allow_reservation);

      this.$store.dispatch("saveCafe");
    },
    onToggleTakeaway() {
      this.allow_takeaway = !this.allow_takeaway;

      this.$store.commit("setPreorderAllowTakeaway", this.allow_takeaway);

      this.$store.dispatch("saveCafe");
    },
  },
  computed: {
    isValid() {
      return this.allow_reservation || this.allow_takeaway;
    },
  },
  mounted() {
    this.allow_reservation =
      !!this.$store.state.cafe.preorder.allow_reservation;
    this.allow_takeaway = !!this.$store.state.cafe.preorder.allow_takeaway;
  },
};
</script>

<style>
</style>